import type { GeoDataStateCreator } from './types';

// Print Map Types
export type PrintUnit = 'in' | 'mm';
export type PrintOutputFormat = 'png' | 'pdf';

export interface PrintMapsSlice {
  // Configuration state
  printWidth: number;
  printHeight: number;
  printDpi: number;
  printUnit: PrintUnit;
  printOutputFormat: PrintOutputFormat;
  isGenerating: boolean;
  showPrintPreview: boolean;
  fitPreviewToContainer: boolean;
  
  // Actions
  setPrintWidth: (width: number) => void;
  setPrintHeight: (height: number) => void;
  setPrintDpi: (dpi: number) => void;
  setPrintUnit: (unit: PrintUnit) => void;
  setPrintOutputFormat: (format: PrintOutputFormat) => void;
  setIsGenerating: (isGenerating: boolean) => void;
  setShowPrintPreview: (show: boolean) => void;
  setFitPreviewToContainer: (fit: boolean) => void;
  resetPrintConfig: () => void;
}

// Default print configuration
const defaultPrintConfig = {
  printWidth: 8,
  printHeight: 6,
  printDpi: 300,
  printUnit: 'in' as PrintUnit,
  printOutputFormat: 'png' as PrintOutputFormat,
  isGenerating: false,
  showPrintPreview: false,
  fitPreviewToContainer: false,
};

export const createPrintMapsSlice: GeoDataStateCreator<PrintMapsSlice> = (set) => ({
  // Initial state
  ...defaultPrintConfig,
  
  // Actions
  setPrintWidth: (width) => set({ printWidth: width }),
  setPrintHeight: (height) => set({ printHeight: height }),
  setPrintDpi: (dpi) => set({ printDpi: dpi }),
  setPrintUnit: (unit) => set({ printUnit: unit }),
  setPrintOutputFormat: (format) => set({ printOutputFormat: format }),
  setIsGenerating: (isGenerating) => set({ isGenerating }),
  setShowPrintPreview: (show) => set({ showPrintPreview: show }),
  setFitPreviewToContainer: (fit) => set({ fitPreviewToContainer: fit }),
  
  resetPrintConfig: () => set({
    ...defaultPrintConfig,
  }),
});